import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentRole, isTokenPresentAndUnexpired } from "../utilities/auth";

/**
 * Gates a route behind login and (optionally) a specific role.
 *
 * NOTE: this only controls what renders in the browser. The real security
 * boundary is on the backend — every sensitive endpoint independently
 * verifies the JWT and checks the role itself. This component exists purely
 * so the right UI shows up for the right kind of logged-in user.
 */
const ProtectedRoute = ({ children, role }) => {
    if (!isTokenPresentAndUnexpired()) {
        return <Navigate to="/" replace />;
    }

    const currentRole = getCurrentRole();

    if (role && currentRole !== role) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
